import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MapPin, Clock } from 'lucide-react';
const experiences = [{
  title: 'Sierra Nevada',
  location: 'Chile',
  duration: 'Full Day',
  price: '$399',
  img: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Parque Nacional Conguillío',
  location: 'Chile',
  duration: 'Full Day',
  price: '$499',
  img: 'https://images.unsplash.com/photo-1501555088652-021faa106b9b?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Puerto Varas y Termas del Sol',
  location: 'Chile',
  duration: '3 Días',
  price: '$599',
  img: 'https://images.unsplash.com/photo-1542224566-6e85f2e6772f?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Auroras Boreales',
  location: 'Islandia',
  duration: '7 Días',
  price: '$399',
  img: 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Día de los Muertos',
  location: 'Riviera Maya',
  duration: '5 Días',
  price: '$499',
  img: 'https://images.unsplash.com/photo-1512813117056-116f86e1dce4?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Malalcahuello',
  location: 'Chile',
  duration: 'Full Day',
  price: '$599',
  img: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Carretera Austral',
  location: 'Chile',
  duration: '8 Días',
  price: '$399',
  img: 'https://images.unsplash.com/photo-1531219572328-a0171b4448a3?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Cartagena de Indias e Isla San Andrés',
  location: 'Colombia',
  duration: '7 Días',
  price: '$499',
  img: 'https://images.unsplash.com/photo-1583531352515-8884af319dc7?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Tailandia',
  location: 'Sudeste Asiático',
  duration: '12 Días',
  price: '$599',
  img: 'https://images.unsplash.com/photo-1528181304800-259b08848526?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Torres del Paine',
  location: 'Patagonia',
  duration: '6 Días',
  price: '$399',
  img: 'https://images.unsplash.com/photo-1531176175280-33e81d268a39?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Rapa Nui Verano',
  location: 'Isla de Pascua',
  duration: '7 Días',
  price: '$499',
  img: 'https://images.unsplash.com/photo-1518791841217-8f162f1e1131?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Rapa Nui Tapati',
  location: 'Isla de Pascua',
  duration: '8 Días',
  price: '$599',
  img: 'https://images.unsplash.com/photo-1551918120-9739cb430c6d?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Salar de Uyuni',
  location: 'Bolivia',
  duration: '5 Días',
  price: '$399',
  img: 'https://images.unsplash.com/photo-1530541930197-ff16ac917b0e?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Selva Amazónica',
  location: 'Perú',
  duration: '6 Días',
  price: '$499',
  img: 'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'San Pedro de Atacama',
  location: 'Chile',
  duration: '5 Días',
  price: '$599',
  img: 'https://images.unsplash.com/photo-1539635278303-d4002c07eae3?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Rapa Nui',
  location: 'Chile',
  duration: '7 Días',
  price: '$1.350.000',
  img: 'https://images.unsplash.com/photo-1564604761-8b8d6cb45f8c?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Machu Picchu',
  location: 'Perú',
  duration: '6 Días',
  price: '$499',
  img: 'https://images.unsplash.com/photo-1526392060635-9d6019884377?q=80&w=1000&auto=format&fit=crop'
}, {
  title: 'Riviera Maya',
  location: 'México',
  duration: '7 Días',
  price: '$599',
  img: 'https://images.unsplash.com/photo-1518638150340-f706e86654de?q=80&w=1000&auto=format&fit=crop'
}];
export function ExperiencesSection() {
  return <section id="experiencias" className="py-32 md:py-40 px-6 md:px-12 lg:px-24 bg-cream" data-id="element-65">
      <div className="max-w-7xl mx-auto" data-id="element-66">
        {/* Eyebrow & Divider */}
        <div className="mb-16 md:mb-20" data-id="element-67">
          <span className="text-xs font-sans uppercase tracking-[0.3em] text-charcoal/60 block mb-4" data-id="element-68">
            — 02 / EXPERIENCIAS
          </span>
          <div className="w-full h-[1px] bg-charcoal/10 mb-12" data-id="element-69" />

          <div className="flex flex-col md:flex-row md:items-end justify-between gap-8" data-id="element-70">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 1
          }} data-id="element-71">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif italic text-charcoal mb-4 leading-[1.1]" data-id="element-72">
                Nuestras Experiencias
              </h2>
              <p className="text-charcoal/60 font-sans text-sm md:text-base max-w-lg leading-relaxed" data-id="element-73">
                Descubre destinos cuidadosamente seleccionados donde la aventura
                y la conexión se encuentran.
              </p>
            </motion.div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16 mb-16" data-id="element-74">
          {experiences.map((exp, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: idx % 3 * 0.15
        }} className="flex flex-col group cursor-pointer" data-id="element-75">
              <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden mb-6" data-id="element-76">
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors duration-500 z-10" data-id="element-77" />
                <img src={exp.img} alt={exp.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-1000 ease-out" data-id="element-78" />
                <div className="absolute top-4 right-4 z-20 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full" data-id="element-79">
                  <span className="text-sm font-sans font-medium text-charcoal" data-id="element-80">
                    {exp.price}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-4 text-xs font-sans text-charcoal/50 uppercase tracking-wider mb-3" data-id="element-81">
                <div className="flex items-center gap-1" data-id="element-82">
                  <MapPin className="w-3 h-3" data-id="element-83" /> {exp.location}
                </div>
                <div className="flex items-center gap-1" data-id="element-84">
                  <Clock className="w-3 h-3" data-id="element-85" /> {exp.duration}
                </div>
              </div>

              <h3 className="text-2xl font-serif italic text-charcoal leading-tight mb-4" data-id="element-86">
                {exp.title}
              </h3>

              <div className="flex items-center text-sm font-sans font-medium text-rose-primary group-hover:text-rose-light transition-colors mt-auto" data-id="element-87">
                Ver más{' '}
                <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-88" />
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-89">
          <a href="#experiencias" className="inline-flex items-center gap-2 text-sm font-sans uppercase tracking-wider text-charcoal hover:text-rose-primary transition-colors border-b border-charcoal/20 hover:border-rose-primary pb-1" data-id="element-90">
            Ver todas las experiencias <ArrowRight className="w-4 h-4" data-id="element-91" />
          </a>
        </motion.div>
      </div>
    </section>;
}